export const payFrequencyOptions = [
		{ label: "every week", payFrequency: 52, value: "every week" },
		{ label: "every 2 weeks", payFrequency: 26, value: "every 2 weeks" },
		{ label: "every 4 weeks", payFrequency: 13, value: "every 4 weeks" },
		{ label: "every month", payFrequency: 12, value: "every month" },
		{ label: "4-4-5", payFrequency: 12, value: "4-4-5" },
	]